__webpack_require__.p = "https://static.age.awaze.com/search-mfe/9c50b38/_next/";